import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6211af14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Team" }
const _hoisted_2 = { class: "Team-intro-content" }
const _hoisted_3 = { class: "Team-intro-title h1" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "Team-apply-left" }
const _hoisted_6 = { class: "h1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Team-apply-img Team-apply-img--lg" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/team/apply.png 1x, /dev/team/apply@2x.png 2x" }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/dev/team/apply.png",
      alt: "apply team"
    })
  ])
], -1))
const _hoisted_8 = { class: "Team-apply-right" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Team-apply-img Team-apply-img--sm" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/team/apply.png 1x, /dev/team/apply@2x.png 2x" }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/dev/team/apply.png",
      alt: "apply team"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_ParallaxObject = _resolveComponent("ParallaxObject")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_RoundSection = _resolveComponent("RoundSection")!
  const _component_Testimonials = _resolveComponent("Testimonials")!
  const _component_Questions = _resolveComponent("Questions")!
  const _component_LayoutNotConnected = _resolveComponent("LayoutNotConnected")!

  return (_openBlock(), _createBlock(_component_LayoutNotConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createVNode(_component_AppearObject, {
          class: "Team-intro",
          "data-scroll-section": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ParallaxObject, {
              class: "Team-intro-inner grid padded",
              ratio: -0.2
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h1", _hoisted_3, [
                    _createVNode(_component_LineByLine, {
                      innerHTML: _ctx.$t('staff-certified.title1')
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createElementVNode("h2", {
                    class: "Team-intro-subtitle h3",
                    innerHTML: _ctx.$t('staff-certified.description1')
                  }, null, 8, _hoisted_4)
                ])
              ]),
              _: 1
            }, 8, ["ratio"])
          ]),
          _: 1
        }),
        _createVNode(_component_AppearObject, {
          class: "Team-apply",
          "data-scroll-section": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RoundSection, { class: "Team-apply-inner grid padded" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h3", _hoisted_6, [
                    _createVNode(_component_LineByLine, {
                      innerHTML: _ctx.$t('staff-certified.title2')
                    }, null, 8, ["innerHTML"])
                  ]),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "Team-apply-right-text h3",
                    innerHTML: _ctx.$t('staff-certified.description2')
                  }, null, 8, _hoisted_9),
                  _createVNode(_component_ButtonHover, {
                    onClick: _ctx.onApply,
                    to: "/register/staff",
                    class: "Team-apply-right-btn button button--brand"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('staff-certified.cta2')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Testimonials, { content: _ctx.testimonials }, null, 8, ["content"]),
        _createVNode(_component_Questions, {
          title: _ctx.$t('staff-certified.title3'),
          description: _ctx.$t('staff-certified.description3'),
          cta: {to:'/contact', label: _ctx.$t('staff-certified.cta3')},
          onOnClickCta: _ctx.onContact
        }, null, 8, ["title", "description", "cta", "onOnClickCta"])
      ])
    ]),
    _: 1
  }))
}